import type { IconData } from '@stacksjs/iconify-core'

export const cursorHand: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M26.67 13.71h1.52v10.67h-1.52Zm-1.53 13.72H9.91v-1.52H8.38v1.52H6.86V32h21.33v-4.57h-1.52v-3.05h-1.53Zm0 3.05H22.1v-1.53h3.04Zm0-18.29h1.53v1.52h-1.53Zm-3.04 1.52h1.52v4.58H22.1Zm0-3.04h3.04v1.52H22.1Zm-4.57 3.04h1.52v4.58h-1.52Zm-4.58 0h1.53v4.58h-1.53Zm0-3.04h9.15V9.14h-7.62V1.52h-1.53zM9.91 0h3.04v1.52H9.91ZM8.38 19.81h1.53V1.52H8.38v10.67H6.86v1.52h1.52zm-1.52 4.57h1.52v1.53H6.86Zm-1.52-3.05h1.52v3.05H5.34Zm0-7.62h1.52v1.53H5.34Zm-1.53 1.53h1.53v6.09H3.81Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default cursorHand
